export default __webpack_public_path__ + "static/media/RobotoCondensed-Light.315e30bd.ttf";